import domready from 'domready'
import MobileMenuController from './controllers/mobile-menu-controller'

export default function initMobileMenuController () {
  return new Promise((resolve, reject) => {
    domready(() => {
      const element = document.querySelector('.mobile-header')
      if (element) {
        // eslint-disable-next-line no-new
        new MobileMenuController(element)
      }
    })
  })
}
